import {Component} from '../../../../utils/modules'
class LabelsPanContent extends Component {
    render() { 
        return (
          <>
            <div className='fw-normal text-secondary'>Your list of labels will show up here.</div>
          </>
        );
    }
}
 
export default LabelsPanContent;